import React from 'react';
import AppHeader from '../../components/Header/Header';
import AppLayout from '../../components/layout';
import InternacionalMenu from '../../components/ui/InternacionalMenu';
import SectionHeading from '../../components/SectionHeading';
import BreadcrumbNav from '../../components/ui/BreadcrumbNav';
import BannerSection from '../../components/ui/BannerSection';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';


const caminho = [
    { label: 'Home', href: '/', icon: 'bi bi-house-door' },
    { label: 'Internacional' },
    { label: 'Licenciatura' }
];

const blogData = [
  {
    id: 1,
    image: require('../../assets/Internacional/cur_04.jpg'),
    title: 'Análises Clínicas',
    description: 'Formação prática e teórica em áreas chave, com foco em tecnologias avançadas para atuação global, clica no botão para saber mais!',
    link: '#'
  },
  {
    id: 2,
    image: require('../../assets/Internacional/cur_03.jpg'),
    title: 'Enfermagem',
    description: 'No nosso curso de Análises Clínicas, os estudantes internacionais aprendem técnicas avançadas e protocolos globais.',
    link: '#'
  },
  {
    id: 3,
    image: require('../../assets/Internacional/cur_07.jpg'),
    title: 'Gestão de Empresas',
    description: 'Este curso de Gestão de Empresas, vai capacita-lo de competências essenciais para liderar com sucesso em mercados.',
    link: '#'
  },
  {
    id: 4,
    image: require('../../assets/Internacional/cur_02.jpg'),
    title: 'Gestão de Recursos Humanos',
    description: 'Você vai adquirir habilidades essenciais para liderar equipes, otimizar processos e implementar estratégias eficazes de gestão.',
    link: '#'
  },
  {
    id: 5,
    image: require('../../assets/Internacional/cur_05.jpg'),
    title: 'Engenharia Informática',
    description: 'No nosso curso de Engenharia Informática, você aprende tecnologias avançadas e soluções digitais,com foco em inteligência artificial, segurança e programação. ',
    link: '#'
  },
  {
    id: 6,
    image: require('../../assets/Internacional/cur_08.jpg'),
    title: 'Língua Portuguesa',
    description: 'Aprenda português de forma rápida e prática com nosso curso online, adaptado a todos os níveis. Aulas interativas e suporte dedicado para você alcançar fluência. Adquira já, não perca mais tempo! ',
    link: '#'
  },
  {
    id: 7,
    image: require('../../assets/Internacional/cur_06.jpg'),
    title: 'Lingua Inglesa',
    description: 'Vem Aprender inglês de forma prática e eficiente com nossos professores qualificados. Aulas dinâmicas e material atualizado para todos os níveis, oferecemos uma abordagem dinâmica e personalizada para todos ',
    link: '#'
  }
  ,
  {
    id: 8,
    image: require('../../assets/Internacional/cur_01.jpg'),
    title: 'Contabilidade',
    description: 'No curso de Licenciatura em Contabilidade, você adquire conhecimentos em normas internacionais, gestão financeira e auditoria, preparando-se para dominar ferramentas essenciais para uma carreira de sucesso',
    link: '#'
  }
]

function cursos() {
    return (
        <>
        <header id='header'>
        <AppHeader />
        </header>
            <BannerSection
            title="Licenciatura"
            subtitle="Bem-vindo ao Instituto Superior Politécnico Atlântida"
            description={`Descubra um ambiente de aprendizado inspirador e inovador, onde cada jornada educacional é guiada pela excelência.`}
            backgroundImage={require('../../assets/BannerInsternacional.jpg')} 
            backgroundId="instituition-Banner"
            />
        <BreadcrumbNav items={caminho} />
            <main className="px-3 px-md-5 px-xl-5 px-xxl-5 py-2">            
            <br />
            <div className="row flex-row-reverse">
                <InternacionalMenu />
                <div className="col-12 col-md-8 col-lg-9 col-xl-10 col-xxl-10">
                <br />
                <div className="details-magazine" id='detalhes'>
                    <p className="f-reg">
                    <SectionHeading title="Licenciatura  " />
                    A actual estrutura estabelece a constituição de quatro áreas do conhecimento, a saber: Ciências da Saúde, 
                    Ciências das Engenharias e Tecnologia, Ciências da Gestão e Ciência Sociais. Ao todo, são ministrados 15 cursos de 
                    graduação: licenciatura em Direito, Relações Internacionais, Pedagogia, Psicologia, Sociologia, Gestão de Empresa,
                    Gestão de Recursos Humanos, Contabilidade, Economia, Enfermagem, Análises Clínicas, Engenharia Informática, Engenharia Civil, 
                    Farmácia e Fisioterapia.
                    <br /><br />
                    </p>
                    <br />
                </div>
                <br />
                    <section
                        id="cursos"
                        className="py-2"
                        >
                        <Container fluid="md">
                            <div className="text-center mb-5">
                            <h2 className="fw-bold" style={{ fontSize: '2rem' }}>
                                🎓 Nossos Cursos
                            </h2>
                            <p className="text-muted" style={{ fontSize: '1.1rem' }}>
                                Conheça as licenciaturas disponíveis para estudantes internacionais
                            </p>
                            <div
                                style={{
                                width: '60px',
                                height: '4px',
                                backgroundColor: '#28a745',
                                borderRadius: '2px',
                                margin: '10px auto 0 auto',
                                }}
                            ></div>
                            </div>

                            <Row className="g-4">
                            {blogData.map((curso) => (
                                <Col key={curso.id} sm={12} md={6} lg={4} xl={3}>
                                <Card
                                    className="h-100 border-0"
                                    style={{
                                    borderRadius: '1rem',
                                    overflow: 'hidden',
                                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                    }}
                                    onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-6px)';
                                    e.currentTarget.style.boxShadow = '0 12px 32px rgba(40, 167, 69, 0.15)';
                                    }}
                                    onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'none';
                                    e.currentTarget.style.boxShadow = 'none';
                                    }}
                                >
                                    <div style={{ overflow: 'hidden' }}>
                                    <Card.Img
                                        variant="top"
                                        src={curso.image}
                                        style={{
                                        objectFit: 'cover',
                                        height: '180px',
                                        transition: 'transform 0.4s ease',
                                        }}
                                        onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'scale(1.05)';
                                        }}
                                        onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'scale(1)';
                                        }}
                                    />
                                    </div>
                                    <Card.Body className="d-flex flex-column">
                                    <Card.Title className="fw-semibold text-dark">
                                        {curso.title}
                                    </Card.Title>
                                    <Card.Text className="text-muted flex-grow-1">
                                        {curso.description}
                                    </Card.Text>
                                    <a
                                        href={curso.link}
                                        className="btn btn-sm btn-outline-success mt-3 align-self-start"
                                    >
                                        Saber mais →
                                    </a>
                                    </Card.Body>
                                </Card>
                                </Col>
                            ))}
                            </Row>
                        </Container>
                        </section>
                <br /><br />
                </div>
            </div>
            <br />
            <br />
            <br />
            <br />
            <br />
            </main>
        <AppLayout />
        </>
       
    );
}

export default cursos;